/** DEMO ONLY — explains what is mocked. */
import React from "react";
import { Paper, Typography, Box } from "@mui/material";

export default function DemoNotes() {
  return (
    <Paper variant="outlined" sx={{ p: 2, backgroundColor: "#FAFAFA" }}>
      <Typography variant="subtitle2" gutterBottom>
        About this demo
      </Typography>
      <Box component="ul" sx={{ m: 0, pl: 2.5, fontSize: 13, color: "text.secondary" }}>
        <li>Bands, products, fabrics and prices here are made up.</li>
        <li>Nothing is saved to the real system — a page refresh keeps your
          changes only in this browser.</li>
        <li>
          This mirrors the planned behaviour: the admin defines the quantity
          bands once, each product's prices follow those bands, a few products
          get their own bands, and a quantity outside a product's bands is
          rejected rather than priced.
        </li>
        <li>Use "Reset demo" to return to the starting data.</li>
      </Box>
    </Paper>
  );
}
